import React from 'react';
import { motion } from 'framer-motion';
import { Shield } from 'lucide-react';
import { BRANDS } from '../content';

export default function Brands() {
  return (
    <section
      data-testid="brands-section"
      style={{
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Header — dark bg */}
      <div style={{ background: 'var(--bg)', borderTop: '1px solid var(--border)', padding: '4rem 0 3rem' }}>
        <div className="wrap">
          <div style={{
            display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between',
            gap: '2rem', flexWrap: 'wrap',
          }}>
            <div style={{ flex: '1 1 400px' }}>
              <div className="pill" style={{ marginBottom: '1rem' }}>Güvenilir Markalar</div>
              <h2 className="h2" style={{ marginBottom: '.875rem' }}>
                Premium <span style={{ color: 'var(--blue)' }}>Partner Network</span>
              </h2>
              <p className="body" style={{ maxWidth: 460, color: 'var(--text2)' }}>
                Dünya standartlarında lastik markalarıyla, orijinal ürün garantisi ve profesyonel
                montaj hizmeti sunuyoruz.
              </p>
            </div>

            <div style={{
              display: 'flex', alignItems: 'center', gap: '.75rem',
              background: 'var(--card)', border: '1px solid var(--border)',
              borderRadius: 'var(--rl)', padding: '1rem 1.5rem',
            }}>
              <div style={{
                width: 42, height: 42, borderRadius: 11,
                background: 'rgba(16,185,129,.12)', border: '1px solid rgba(16,185,129,.25)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                color: 'var(--green)',
              }}>
                <Shield size={18} strokeWidth={2} />
              </div>
              <div>
                <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontWeight: 700, fontSize: '.95rem', color: 'var(--text)' }}>
                  Orijinal Ürün
                </div>
                <div style={{ fontSize: '.75rem', color: 'var(--text2)' }}>100% Garanti</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* White band — full width */}
      <div style={{
        background: '#fff',
        padding: '3rem 0',
      }}>
        <div className="wrap">
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(7, 1fr)',
            gap: '1.5rem',
            alignItems: 'center',
          }} className="brands-grid">
            {BRANDS.map((brand, i) => (
              <motion.div
                key={brand.name}
                data-testid={`brand-${brand.name.toLowerCase()}`}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: .45, delay: i * .05 }}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  height: 120,
                  padding: '1rem',
                  transition: 'transform .25s',
                  cursor: 'default',
                  background: '#fff',
                  borderRadius: '12px',
                }}
                onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.08)'}
                onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
              >
                <img
                  src={brand.logo}
                  alt={brand.name}
                  loading="lazy"
                  style={{
                    maxWidth: '100%',
                    maxHeight: 80,
                    objectFit: 'contain',
                  }}
                />
              </motion.div>
            ))}
          </div>
        </div>
      </div>

      <style>{`
        @media(max-width:768px){
          .brands-grid{grid-template-columns:repeat(3,1fr)!important;gap:1rem!important}
          .brands-grid>div{height:100px!important;padding:.75rem!important}
          .brands-grid img{max-height:70px!important}
        }
        @media(max-width:480px){
          .brands-grid{grid-template-columns:repeat(2,1fr)!important;gap:.75rem!important}
          .brands-grid>div{height:90px!important;padding:.5rem!important}
          .brands-grid img{max-height:60px!important}
        }
      `}</style>
    </section>
  );
}
